export const NUMBER_REGEX = /^\d+$/
